import React from 'react';
import { entityLabel, selectedEntityIds } from '../utils/entitySelection';
import { useLinkedEntityCards } from './linked-entities/LinkedEntityCardHost';

export default function EntityPartyLinks({ entity = {}, clients = [], suppliers = [], staff = [] }) {
  const { openEntityCard } = useLinkedEntityCards();
  const groups = [['client', 'Clienti', clients], ['supplier', 'Fornitori', suppliers], ['staff', 'Team', staff]];
  if (!groups.some(([kind]) => selectedEntityIds(entity, kind).length > 1)) return null;
  return <section className="entity-detail-dialog__card entity-detail-dialog__card--full">
    <h3>Persone e aziende collegate</h3>
    {groups.map(([kind, label, options]) => {
      const ids = selectedEntityIds(entity, kind);
      return ids.length ? <div key={kind} className="mb-3"><strong>{label}</strong><div className="flex flex-wrap gap-2">
        {ids.map((id) => <button key={id} type="button" className="rounded-lg border border-[var(--border)] bg-[var(--surface-raised)] px-3 py-2 text-[var(--text-primary)]"
          onClick={() => openEntityCard({ entityType: kind, entityId: id })}>
          {entityLabel(options.find((option) => String(option.id) === id)) || `${label} ${id}`}
        </button>)}
      </div></div> : null;
    })}
  </section>;
}
